module.exports = __webpack_public_path__ + "img/bg_duoduop_des_2.fbd1b200.png";